// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General */
/* border radius of layout element e.g. card, sidebar */
/* transition duration of layout elements e.g. sidebar, overlay menus */
* {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  font-family: var(--font-family);
  color: var(--text-color);
  background-color: var(--surface-ground);
  margin: 0;
  padding: 0;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
  color: var(--primary-color);
}

.layout-wrapper {
  min-height: 100vh;
}

.layout-topbar {
  position: fixed;
  height: 3.5rem;
  z-index: 997;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 2rem;
  background-color: var(--surface-card);
  transition: left 0.2s;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}
.layout-topbar .layout-topbar-logo {
  display: flex;
  align-items: center;
  color: var(--surface-900);
  font-size: 1.5rem;
  font-weight: 500;
  width: 180px;
  border-radius: 12px;
}
.layout-topbar .layout-topbar-logo img {
  height: 2.5rem;
  margin-right: 0.5rem;
}
.layout-topbar .layout-topbar-logo:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--text-color-secondary);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.layout-topbar .layout-topbar-button:hover {
  color: var(--text-color);
  background-color: var(--surface-hover);
}
.layout-topbar .layout-topbar-button:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button i {
  font-size: 1.5rem;
}
.layout-topbar .layout-topbar-button span {
  font-size: 1rem;
}
.layout-topbar .layout-menu-button {
  margin-left: 2rem;
}
.layout-topbar .layout-topbar-menu-button {
  display: none;
}
.layout-topbar .layout-topbar-menu-button i {
  font-size: 1.25rem;
}
.layout-topbar .layout-topbar-menu {
  margin: 0 0 0 auto;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button {
  margin-left: 1rem;
  position: relative;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar {
  position: absolute;
  width: 200px;
  right: 0;
  top: 48px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  display: none;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.02), 0 0 2px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.08);
}
.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar .p-link {
  margin-bottom: 8px;
  padding: 0.5rem;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar .p-link:hover {
  background-color: var(--surface-hover);
}
.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar a {
  color: gray !important;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar::before {
  content: "";
  display: block;
  opacity: 0;
  background-color: black;
  width: 100%;
  height: 30px;
  position: absolute;
  top: -24px;
  right: 0;
  transform: translateY(-100);
}
.layout-topbar .layout-topbar-button:hover .menu-topbar {
  display: block;
}

@media (max-width: 991px) {
  .layout-topbar {
    justify-content: space-between;
  }
  .layout-topbar .layout-topbar-logo {
    width: auto;
    order: 2;
  }
  .layout-topbar .layout-menu-button {
    margin-left: 0;
    order: 1;
  }
  .layout-topbar .layout-topbar-menu-button {
    display: inline-flex;
    margin-left: 0;
    order: 3;
  }
  .layout-topbar .layout-topbar-menu {
    order: 3;
    display: block;
    margin: 0;
  }
  .layout-topbar .layout-topbar-menu span {
    display: none;
  }
  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {
    display: block;
  }
}
.layout-sidebar {
  position: fixed;
  width: 300px;
  height: calc(100vh - 3.5rem);
  z-index: 999;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
  top: 3.5rem;
  left: 0;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  padding: 0.5rem 0.5rem;
  transition: width 0.3s ease-in-out;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}

.hide-menu {
  transform: translateX(-100%);
  transition: left 0.3s ease-in-out;
}

.layout-menu {
  margin: 0;
  padding: 0;
  list-style-type: none;
  -webkit-user-select: none;
          user-select: none;
}
.layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
  font-size: 0.857rem;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--surface-900);
  margin: 0.75rem 0;
}
.layout-menu .layout-root-menuitem > a {
  display: none;
}
.layout-menu li.active-menuitem > a .layout-submenu-toggler {
  transform: rotate(-180deg);
}
.layout-menu li.active-menuitem > ul {
  max-height: auto;
}
.layout-menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.layout-menu ul .submenu-text {
  font-weight: 400;
  font-size: 0.9rem;
}
.layout-menu ul a {
  display: flex;
  align-items: center;
  position: relative;
  outline: 0 none;
  color: var(--text-color);
  cursor: pointer;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.layout-menu ul a .layout-menuitem-icon {
  margin-right: 0.5rem;
}
.layout-menu ul a .layout-submenu-toggler {
  font-size: 75%;
  margin-left: auto;
  transition: transform 0.2s;
}
.layout-menu ul a.rotated-icon .layout-menuitem-icon {
  transform: rotate(90deg);
}
.layout-menu ul a.active-route {
  font-weight: 700;
  color: var(--primary-color);
}
.layout-menu ul a:hover {
  background-color: var(--surface-hover);
}
.layout-menu ul a:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: inset var(--focus-ring);
}
.layout-menu ul ul {
  overflow: hidden;
  max-height: 0;
  border-radius: 12px;
}
.layout-menu ul ul li a {
  margin-left: 1rem;
}
.layout-menu ul ul li li a {
  margin-left: 2rem;
}
.layout-menu ul ul li li li a {
  margin-left: 2.5rem;
}
.layout-menu ul ul li li li li a {
  margin-left: 3rem;
}
.layout-menu ul ul li li li li li a {
  margin-left: 3.5rem;
}
.layout-menu ul ul li li li li li li a {
  margin-left: 4rem;
}

.layout-submenu-enter-active {
  max-height: 1000px !important;
  transition: max-height 1s ease-in-out;
}

.layout-submenu-enter-done {
  max-height: 1000px !important;
}

.layout-submenu-exit {
  max-height: 1000px !important;
}

.layout-submenu-exit-active {
  overflow: hidden;
  max-height: 0 !important;
  transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgb(179, 177, 177);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgb(150, 150, 150);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgb(135, 135, 135);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:active {
  background: rgb(120, 120, 120);
  border-radius: 10px;
}

.active-item .submenu-text {
  font-weight: 700 !important;
  color: var(--primary-color);
}

.layout-config-button {
  display: block;
  position: fixed;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  background: var(--primary-color);
  color: var(--primary-color-text);
  text-align: center;
  top: 50%;
  right: 0;
  margin-top: -1.5rem;
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: background-color var(--transition-duration);
  overflow: hidden;
  cursor: pointer;
  z-index: 999;
  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);
}
.layout-config-button i {
  font-size: 2rem;
  line-height: inherit;
  transform: rotate(0deg);
  transition: transform 1s;
}
.layout-config-button:hover {
  background: var(--primary-400);
}

.layout-config-sidebar.p-sidebar .p-sidebar-content {
  padding-left: 2rem;
  padding-right: 2rem;
}

.layout-main-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  padding: 4.5rem 1rem 2rem 1rem;
  transition: margin-left 0.2s;
  margin-left: 300px;
}

.layout-main {
  flex: 1 1 auto;
}

.hide-sidebar {
  margin-left: 0;
}

.layout-mask {
  background-color: black;
  opacity: 0.75;
  z-index: 50000;
  height: 100vh;
  width: 100vw;
  position: relative;
  top: 0;
  left: 0;
}

.layout-footer {
  transition: margin-left 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  border-top: 1px solid var(--surface-border);
}

@media screen and (min-width: 1960px) {
  .layout-main,
  .landing-wrapper {
    width: 1504px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
@media (min-width: 992px) {
  .layout-wrapper.layout-overlay .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper.layout-overlay .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
    top: 0;
    height: 100vh;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .layout-wrapper.layout-overlay.layout-overlay-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-wrapper.layout-static .layout-main-container {
    margin-left: 300px;
  }
  .layout-wrapper.layout-static.layout-static-inactive .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
  }
  .layout-wrapper.layout-static.layout-static-inactive .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper .layout-mask {
    display: none;
  }
}
@media (max-width: 991px) {
  .blocked-scroll {
    overflow: hidden;
  }
  .overlay {
    background-color: black;
    z-index: 500;
  }
  .layout-wrapper .layout-main-container {
    margin-left: 0 !important;
    padding-left: 1rem !important;
  }
  .layout-wrapper .layout-sidebar {
    top: 0;
    height: 100%;
  }
  .layout-wrapper .layout-mask {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 100%;
    background-color: var(--maskbg);
  }
  .layout-wrapper.layout-mobile-active .layout-sidebar {
    transform: translateX(0);
  }
}
/* Utils */
.clearfix:after {
  content: " ";
  display: block;
  clear: both;
}

.card {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: var(--card-shadow);
  border-radius: 12px;
}
.card:last-child {
  margin-bottom: 0;
}

.p-toast.p-toast-top-right, .p-toast.p-toast-top-left, .p-toast.p-toast-top-center {
  top: 100px;
}

h1, h2, h3, h4, h5, h6 {
  margin: 1.5rem 0 1rem 0;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: var(--surface-900);
}
h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {
  margin-top: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

mark {
  background: #FFF8E1;
  padding: 0.25rem 0.4rem;
  border-radius: 12px;
  font-family: monospace;
}

blockquote {
  margin: 1rem 0;
  padding: 0 2rem;
  border-left: 4px solid #90A4AE;
}

hr {
  border-top: solid var(--surface-border);
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}

p {
  margin: 0 0 1rem 0;
  line-height: 1.5;
}
p:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/layout/styles/_variables.scss","webpack://./src/layout/styles/_main.scss","webpack://./src/layout/styles/layout.scss","webpack://./src/layout/styles/_topbar.scss","webpack://./src/layout/styles/_mixins.scss","webpack://./src/layout/styles/_menu.scss","webpack://./src/layout/styles/_config.scss","webpack://./src/layout/styles/_content.scss","webpack://./src/layout/styles/_footer.scss","webpack://./src/layout/styles/_responsive.scss","webpack://./src/layout/styles/_utils.scss","webpack://./src/layout/styles/_typography.scss"],"names":[],"mappings":"AAAA,YAAA;AACgC,uDAAA;AACA,uEAAA;ACFhC;EACI,sBAAA;ACIJ;;ADDA;EACI,YAAA;ACIJ;;ADDA;EACI,+BAAA;EACA,wBAAA;EACA,uCAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;ACIJ;;ADDA;EACI,qBAAA;EACA,2BAAA;ACIJ;;ADDA;EACI,iBAAA;ACIJ;;AC7BA;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,6GAAA;ADgCJ;AC9BI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;ADgCR;AC9BQ;EACI,cAAA;EACA,oBAAA;ADgCZ;AC7BQ;EC3BJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AF2DJ;AC9BI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;ADgCR;AC9BQ;EACI,wBAAA;EACA,sCAAA;ADgCZ;AC7BQ;ECjDJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AFiFJ;AC/BQ;EACI,iBAAA;ADiCZ;AC9BQ;EACI,eAAA;ADgCZ;AC5BI;EACI,iBAAA;AD8BR;AC3BI;EACI,aAAA;AD6BR;AC3BQ;EACI,kBAAA;AD6BZ;ACzBI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AD2BR;ACzBQ;EACI,iBAAA;EACA,kBAAA;AD2BZ;ACzBY;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,qGAAA;AD2BhB;ACzBgB;EACI,kBAAA;EACA,eAAA;AD2BpB;ACxBgB;EACI,sCAAA;AD0BpB;ACvBgB;EACI,sBAAA;ADyBpB;ACrBY;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;ADuBhB;AClBI;EACI,cAAA;ADoBR;;AChBA;EACI;IACI,8BAAA;EDmBN;ECjBM;IACI,WAAA;IACA,QAAA;EDmBV;EChBM;IACI,cAAA;IACA,QAAA;EDkBV;ECfM;IACI,oBAAA;IACA,cAAA;IACA,QAAA;EDiBV;ECbM;IACI,QAAA;IACA,cAAA;IACA,SAAA;EDeV;ECbU;IACI,aAAA;EDed;ECbU;IACI,cAAA;EDed;AACF;AGnLA;EACE,eAAA;EACA,YAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,qCAAA;EACA,wCAAA;EACA,sBAAA;EACA,kCAAA;EACA,6GAAA;AHqLF;;AGjLA;EACE,4BAAA;EACA,iCAAA;AHoLF;;AGjLA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;AHoLF;AGjLI;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AHmLN;AGhLI;EACE,aAAA;AHkLN;AG5KM;EACE,0BAAA;AH8KR;AG1KI;EACE,gBAAA;AH4KN;AGxKE;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AH0KJ;AGxKI;EACE,gBAAA;EACA,iBAAA;AH0KN;AGvKI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBLxEQ;EKyER,kDAAA;AHyKN;AGtKM;EACE,oBAAA;AHwKR;AGrKM;EACE,cAAA;EACA,iBAAA;EACA,0BAAA;AHuKR;AGnKQ;EACE,wBAAA;AHqKV;AGjKM;EACE,gBAAA;EACA,2BAAA;AHmKR;AGhKM;EACE,sCAAA;AHkKR;AG/JM;ED9FF,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;AFgQJ;AGhKI;EACE,gBAAA;EACA,aAAA;EACA,mBL7GQ;AE+Qd;AG/JQ;EACE,iBAAA;AHiKV;AG7JU;EACE,iBAAA;AH+JZ;AG3JY;EACE,mBAAA;AH6Jd;AGzJc;EACE,iBAAA;AH2JhB;AGvJgB;EACE,mBAAA;AHyJlB;AGrJkB;EACE,iBAAA;AHuJpB;;AG3IA;EACE,6BAAA;EACA,qCAAA;AH8IF;;AG3IA;EACE,6BAAA;AH8IF;;AG3IA;EACE,6BAAA;AH8IF;;AG3IA;EACE,gBAAA;EACA,wBAAA;EACA,qDAAA;AH8IF;;AG3IA;EACE,UAAA;EACA,WAAA;AH8IF;;AG3IA;EACE,8BAAA;EACA,mBAAA;AH8IF;;AG3IA;EACE,8BAAA;EACA,mBAAA;AH8IF;;AG3IA;EACE,8BAAA;EACA,mBAAA;AH8IF;;AG3IA;EACE,8BAAA;EACA,mBAAA;AH8IF;;AGzIE;EACE,2BAAA;EACA,2BAAA;AH4IJ;;AInVA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,4CAAA;EACA,+CAAA;EACA,0BAAA;EACA,6BAAA;EACA,uDAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,+CAAA;AJsVJ;AIpVI;EACI,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AJsVR;AInVI;EACI,8BAAA;AJqVR;;AI/UQ;EACI,kBAAA;EACA,mBAAA;AJkVZ;;AKxXA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;AL2XJ;;AKxXA;EACI,cAAA;AL2XJ;;AKxXA;EACI,cAAA;AL2XJ;;AKxXA;EACI,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AL2XJ;;AMrZA;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2CAAA;ANwZJ;;AO9ZA;EACE;;IAEE,aAAA;IACA,4BAAA;IACA,6BAAA;EPiaF;AACF;AO9ZA;EAGM;IACE,cAAA;IACA,kBAAA;EP8ZN;EO3ZI;IACE,4BAAA;IACA,OAAA;IACA,MAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;EP6ZN;EOzZM;IACE,wBAAA;EP2ZR;EOrZI;IACE,kBAAA;EPuZN;EOnZM;IACE,4BAAA;IACA,OAAA;EPqZR;EOlZM;IACE,cAAA;IACA,kBAAA;EPoZR;EO/YE;IACE,aAAA;EPiZJ;AACF;AO7YA;EACE;IACE,gBAAA;EP+YF;EO5YA;IACE,uBAAA;IACA,YAAA;EP8YF;EO1YE;IACE,yBAAA;IACA,6BAAA;EP4YJ;EOzYE;IACE,MAAA;IACA,YAAA;EP2YJ;EOxYE;IACE,cAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,+BAAA;EP0YJ;EOtYI;IACE,wBAAA;EPwYN;AACF;AQpeA,UAAA;AACA;EACI,YAAA;EACA,cAAA;EACA,WAAA;ARseJ;;AQneA;EACI,+BAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBVZU;AEkfd;AQpeI;EACI,gBAAA;ARseR;;AQjeI;EAGI,UAAA;ARkeR;;AS1fA;EACI,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AT6fJ;AS3fI;EACI,aAAA;AT6fR;;ASzfA;EACI,iBAAA;AT4fJ;;ASzfA;EACI,eAAA;AT4fJ;;ASzfA;EACI,kBAAA;AT4fJ;;ASzfA;EACI,iBAAA;AT4fJ;;ASzfA;EACI,kBAAA;AT4fJ;;ASzfA;EACI,eAAA;AT4fJ;;ASzfA;EACI,mBAAA;EACA,uBAAA;EACA,mBXtCU;EWuCV,sBAAA;AT4fJ;;ASzfA;EACI,cAAA;EACA,eAAA;EACA,8BAAA;AT4fJ;;ASzfA;EACI,uCAAA;EACA,uBAAA;EACA,cAAA;AT4fJ;;ASzfA;EACI,kBAAA;EACA,gBAAA;AT4fJ;AS1fI;EACI,gBAAA;AT4fR","sourcesContent":["/* General */\n$borderRadius:12px;             /* border radius of layout element e.g. card, sidebar */ \n$transitionDuration:.2s;        /* transition duration of layout elements e.g. sidebar, overlay menus */ ","* {\n    box-sizing: border-box;\n}\n\nhtml {\n    height: 100%;\n}\n\nbody {\n    font-family: var(--font-family);\n    color: var(--text-color);\n    background-color: var(--surface-ground);\n    margin: 0;\n    padding: 0;\n    min-height: 100%;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na {\n    text-decoration: none;\n    color: var(--primary-color);\n}\n\n.layout-wrapper {\n    min-height: 100vh;\n}","/* General */\n/* border radius of layout element e.g. card, sidebar */\n/* transition duration of layout elements e.g. sidebar, overlay menus */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  font-family: var(--font-family);\n  color: var(--text-color);\n  background-color: var(--surface-ground);\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none;\n  color: var(--primary-color);\n}\n\n.layout-wrapper {\n  min-height: 100vh;\n}\n\n.layout-topbar {\n  position: fixed;\n  height: 3.5rem;\n  z-index: 997;\n  left: 0;\n  top: 0;\n  width: 100%;\n  padding: 0 2rem;\n  background-color: var(--surface-card);\n  transition: left 0.2s;\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n.layout-topbar .layout-topbar-logo {\n  display: flex;\n  align-items: center;\n  color: var(--surface-900);\n  font-size: 1.5rem;\n  font-weight: 500;\n  width: 180px;\n  border-radius: 12px;\n}\n.layout-topbar .layout-topbar-logo img {\n  height: 2.5rem;\n  margin-right: 0.5rem;\n}\n.layout-topbar .layout-topbar-logo:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  color: var(--text-color-secondary);\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.layout-topbar .layout-topbar-button:hover {\n  color: var(--text-color);\n  background-color: var(--surface-hover);\n}\n.layout-topbar .layout-topbar-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button i {\n  font-size: 1.5rem;\n}\n.layout-topbar .layout-topbar-button span {\n  font-size: 1rem;\n}\n.layout-topbar .layout-menu-button {\n  margin-left: 2rem;\n}\n.layout-topbar .layout-topbar-menu-button {\n  display: none;\n}\n.layout-topbar .layout-topbar-menu-button i {\n  font-size: 1.25rem;\n}\n.layout-topbar .layout-topbar-menu {\n  margin: 0 0 0 auto;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  align-items: center;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button {\n  margin-left: 1rem;\n  position: relative;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar {\n  position: absolute;\n  width: 200px;\n  right: 0;\n  top: 48px;\n  background-color: white;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem;\n  display: none;\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.02), 0 0 2px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.08);\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar .p-link {\n  margin-bottom: 8px;\n  padding: 0.5rem;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar .p-link:hover {\n  background-color: var(--surface-hover);\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar a {\n  color: gray !important;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button .menu-topbar::before {\n  content: \"\";\n  display: block;\n  opacity: 0;\n  background-color: black;\n  width: 100%;\n  height: 30px;\n  position: absolute;\n  top: -24px;\n  right: 0;\n  transform: translateY(-100);\n}\n.layout-topbar .layout-topbar-button:hover .menu-topbar {\n  display: block;\n}\n\n@media (max-width: 991px) {\n  .layout-topbar {\n    justify-content: space-between;\n  }\n  .layout-topbar .layout-topbar-logo {\n    width: auto;\n    order: 2;\n  }\n  .layout-topbar .layout-menu-button {\n    margin-left: 0;\n    order: 1;\n  }\n  .layout-topbar .layout-topbar-menu-button {\n    display: inline-flex;\n    margin-left: 0;\n    order: 3;\n  }\n  .layout-topbar .layout-topbar-menu {\n    order: 3;\n    display: block;\n    margin: 0;\n  }\n  .layout-topbar .layout-topbar-menu span {\n    display: none;\n  }\n  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {\n    display: block;\n  }\n}\n.layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 3.5rem);\n  z-index: 999;\n  overflow-y: auto;\n  user-select: none;\n  top: 3.5rem;\n  left: 0;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  padding: 0.5rem 0.5rem;\n  transition: width 0.3s ease-in-out;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.hide-menu {\n  transform: translateX(-100%);\n  transition: left 0.3s ease-in-out;\n}\n\n.layout-menu {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  user-select: none;\n}\n.layout-menu .layout-root-menuitem > .layout-menuitem-root-text {\n  font-size: 0.857rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--surface-900);\n  margin: 0.75rem 0;\n}\n.layout-menu .layout-root-menuitem > a {\n  display: none;\n}\n.layout-menu li.active-menuitem > a .layout-submenu-toggler {\n  transform: rotate(-180deg);\n}\n.layout-menu li.active-menuitem > ul {\n  max-height: auto;\n}\n.layout-menu ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.layout-menu ul .submenu-text {\n  font-weight: 400;\n  font-size: 0.9rem;\n}\n.layout-menu ul a {\n  display: flex;\n  align-items: center;\n  position: relative;\n  outline: 0 none;\n  color: var(--text-color);\n  cursor: pointer;\n  font-weight: 600;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  transition: background-color 0.2s, box-shadow 0.2s;\n}\n.layout-menu ul a .layout-menuitem-icon {\n  margin-right: 0.5rem;\n}\n.layout-menu ul a .layout-submenu-toggler {\n  font-size: 75%;\n  margin-left: auto;\n  transition: transform 0.2s;\n}\n.layout-menu ul a.rotated-icon .layout-menuitem-icon {\n  transform: rotate(90deg);\n}\n.layout-menu ul a.active-route {\n  font-weight: 700;\n  color: var(--primary-color);\n}\n.layout-menu ul a:hover {\n  background-color: var(--surface-hover);\n}\n.layout-menu ul a:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: inset var(--focus-ring);\n}\n.layout-menu ul ul {\n  overflow: hidden;\n  max-height: 0;\n  border-radius: 12px;\n}\n.layout-menu ul ul li a {\n  margin-left: 1rem;\n}\n.layout-menu ul ul li li a {\n  margin-left: 2rem;\n}\n.layout-menu ul ul li li li a {\n  margin-left: 2.5rem;\n}\n.layout-menu ul ul li li li li a {\n  margin-left: 3rem;\n}\n.layout-menu ul ul li li li li li a {\n  margin-left: 3.5rem;\n}\n.layout-menu ul ul li li li li li li a {\n  margin-left: 4rem;\n}\n\n.layout-submenu-enter-active {\n  max-height: 1000px !important;\n  transition: max-height 1s ease-in-out;\n}\n\n.layout-submenu-enter-done {\n  max-height: 1000px !important;\n}\n\n.layout-submenu-exit {\n  max-height: 1000px !important;\n}\n\n.layout-submenu-exit-active {\n  overflow: hidden;\n  max-height: 0 !important;\n  transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgb(179, 177, 177);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgb(150, 150, 150);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgb(135, 135, 135);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:active {\n  background: rgb(120, 120, 120);\n  border-radius: 10px;\n}\n\n.active-item .submenu-text {\n  font-weight: 700 !important;\n  color: var(--primary-color);\n}\n\n.layout-config-button {\n  display: block;\n  position: fixed;\n  width: 3rem;\n  height: 3rem;\n  line-height: 3rem;\n  background: var(--primary-color);\n  color: var(--primary-color-text);\n  text-align: center;\n  top: 50%;\n  right: 0;\n  margin-top: -1.5rem;\n  border-top-left-radius: var(--border-radius);\n  border-bottom-left-radius: var(--border-radius);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  transition: background-color var(--transition-duration);\n  overflow: hidden;\n  cursor: pointer;\n  z-index: 999;\n  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);\n}\n.layout-config-button i {\n  font-size: 2rem;\n  line-height: inherit;\n  transform: rotate(0deg);\n  transition: transform 1s;\n}\n.layout-config-button:hover {\n  background: var(--primary-400);\n}\n\n.layout-config-sidebar.p-sidebar .p-sidebar-content {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.layout-main-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  justify-content: space-between;\n  padding: 4.5rem 1rem 2rem 1rem;\n  transition: margin-left 0.2s;\n  margin-left: 300px;\n}\n\n.layout-main {\n  flex: 1 1 auto;\n}\n\n.hide-sidebar {\n  margin-left: 0;\n}\n\n.layout-mask {\n  background-color: black;\n  opacity: 0.75;\n  z-index: 50000;\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n\n.layout-footer {\n  transition: margin-left 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 1rem;\n  border-top: 1px solid var(--surface-border);\n}\n\n@media screen and (min-width: 1960px) {\n  .layout-main,\n  .landing-wrapper {\n    width: 1504px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .layout-wrapper.layout-overlay .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper.layout-overlay .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n    top: 0;\n    height: 100vh;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .layout-wrapper.layout-overlay.layout-overlay-active .layout-sidebar {\n    transform: translateX(0);\n  }\n  .layout-wrapper.layout-static .layout-main-container {\n    margin-left: 300px;\n  }\n  .layout-wrapper.layout-static.layout-static-inactive .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n  }\n  .layout-wrapper.layout-static.layout-static-inactive .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper .layout-mask {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .blocked-scroll {\n    overflow: hidden;\n  }\n  .overlay {\n    background-color: black;\n    z-index: 500;\n  }\n  .layout-wrapper .layout-main-container {\n    margin-left: 0 !important;\n    padding-left: 1rem !important;\n  }\n  .layout-wrapper .layout-sidebar {\n    top: 0;\n    height: 100%;\n  }\n  .layout-wrapper .layout-mask {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 998;\n    width: 100%;\n    height: 100%;\n    background-color: var(--maskbg);\n  }\n  .layout-wrapper.layout-mobile-active .layout-sidebar {\n    transform: translateX(0);\n  }\n}\n/* Utils */\n.clearfix:after {\n  content: \" \";\n  display: block;\n  clear: both;\n}\n\n.card {\n  background: var(--surface-card);\n  border: 1px solid var(--surface-border);\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--card-shadow);\n  border-radius: 12px;\n}\n.card:last-child {\n  margin-bottom: 0;\n}\n\n.p-toast.p-toast-top-right, .p-toast.p-toast-top-left, .p-toast.p-toast-top-center {\n  top: 100px;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 1.5rem 0 1rem 0;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--surface-900);\n}\nh1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {\n  margin-top: 0;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\nmark {\n  background: #FFF8E1;\n  padding: 0.25rem 0.4rem;\n  border-radius: 12px;\n  font-family: monospace;\n}\n\nblockquote {\n  margin: 1rem 0;\n  padding: 0 2rem;\n  border-left: 4px solid #90A4AE;\n}\n\nhr {\n  border-top: solid var(--surface-border);\n  border-width: 1px 0 0 0;\n  margin: 1rem 0;\n}\n\np {\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\np:last-child {\n  margin-bottom: 0;\n}",".layout-topbar {\n    position: fixed;\n    height: 3.5rem;\n    z-index: 997;\n    left: 0;\n    top: 0;\n    width: 100%;\n    padding: 0 2rem;\n    background-color: var(--surface-card);\n    transition: left $transitionDuration;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08);\n\n    .layout-topbar-logo {\n        display: flex;\n        align-items: center;\n        color: var(--surface-900);\n        font-size: 1.5rem;\n        font-weight: 500;\n        width: 180px;\n        border-radius: 12px;\n\n        img {\n            height: 2.5rem;\n            margin-right: .5rem;\n        }\n\n        &:focus {\n            @include focused();\n        }\n    }\n\n    .layout-topbar-button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        color: var(--text-color-secondary);\n        border-radius: 50%;\n        width: 3rem;\n        height: 3rem;\n        cursor: pointer;\n        transition: background-color $transitionDuration;\n\n        &:hover {\n            color: var(--text-color);\n            background-color: var(--surface-hover);\n        }\n\n        &:focus {\n            @include focused();\n        }\n\n        i {\n            font-size: 1.5rem;\n        }\n\n        span {\n            font-size: 1rem;\n        }\n    }\n\n    .layout-menu-button {\n        margin-left: 2rem;\n    }\n\n    .layout-topbar-menu-button {\n        display: none;\n\n        i {\n            font-size: 1.25rem;\n        }\n    }\n\n    .layout-topbar-menu {\n        margin: 0 0 0 auto;\n        padding: 0;\n        list-style: none;\n        display: flex;\n        align-items: center;\n\n        .layout-topbar-button {\n            margin-left: 1rem;\n            position: relative;\n\n            .menu-topbar {\n                position: absolute;\n                width: 200px;\n                right: 0;\n                top: 48px;\n                background-color: white;\n                border-radius: 8px;\n                display: flex;\n                flex-direction: column;\n                padding: 0.5rem;\n                display: none;\n                box-shadow: 0 3px 5px rgba(0,0,0,.02), 0 0 2px rgba(0,0,0,.05), 0 1px 4px rgba(0,0,0,.08);\n                \n                .p-link {\n                    margin-bottom: 8px;\n                    padding: 0.5rem;\n                }\n\n                .p-link:hover {\n                    background-color: var(--surface-hover);;\n                }\n\n                a {\n                    color: gray !important;\n                }\n            }\n\n            .menu-topbar::before {\n                content: \"\";\n                display: block;\n                opacity: 0;\n                background-color: black;\n                width: 100%;\n                height: 30px;\n                position: absolute;\n                top: -24px;\n                right: 0;\n                transform: translateY(-100);\n            }\n        }\n    }\n\n    .layout-topbar-button:hover .menu-topbar {\n        display: block;\n    }\n}\n\n@media (max-width: 991px) {\n    .layout-topbar {\n        justify-content: space-between;\n\n        .layout-topbar-logo {\n            width: auto;\n            order: 2;\n        }\n\n        .layout-menu-button {\n            margin-left: 0;\n            order: 1;\n        }\n\n        .layout-topbar-menu-button {\n            display: inline-flex;\n            margin-left: 0;\n            order: 3;\n\n        }\n        \n        .layout-topbar-menu {\n            order: 3;\n            display: block;\n            margin: 0;\n            \n            span {\n                display: none;\n            }\n            &.layout-topbar-menu-mobile-active {\n                display: block\n            }\n        }\n    }\n}\n","@mixin focused() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: var(--focus-ring);\n}\n\n@mixin focused-inset() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: inset var(--focus-ring);\n}\n",".layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 3.5rem);\n  z-index: 999;\n  overflow-y: auto;\n  user-select: none;\n  top: 3.5rem;\n  left: 0;\n  transition: transform $transitionDuration, left $transitionDuration;\n  background-color: var(--surface-overlay);\n  padding: 0.5rem 0.5rem;\n  transition: width 0.3s ease-in-out;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05),\n    0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.hide-menu {\n  transform: translateX(-100%);\n  transition: left 0.3s ease-in-out;\n}\n\n.layout-menu {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  user-select: none;\n\n  .layout-root-menuitem {\n    > .layout-menuitem-root-text {\n      font-size: 0.857rem;\n      text-transform: uppercase;\n      font-weight: 700;\n      color: var(--surface-900);\n      margin: 0.75rem 0;\n    }\n\n    > a {\n      display: none;\n    }\n  }\n\n  li.active-menuitem {\n    > a {\n      .layout-submenu-toggler {\n        transform: rotate(-180deg);\n      }\n    }\n\n    > ul {\n      max-height: auto;\n    }\n  }\n\n  ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n\n    .submenu-text {\n      font-weight: 400;\n      font-size: 0.9rem;\n    }\n\n    a {\n      display: flex;\n      align-items: center;\n      position: relative;\n      outline: 0 none;\n      color: var(--text-color);\n      cursor: pointer;\n      font-weight: 600;\n      padding: 0.75rem 1rem;\n      border-radius: $borderRadius;\n      transition: background-color $transitionDuration,\n        box-shadow $transitionDuration;\n\n      .layout-menuitem-icon {\n        margin-right: 0.5rem;\n      }\n\n      .layout-submenu-toggler {\n        font-size: 75%;\n        margin-left: auto;\n        transition: transform $transitionDuration;\n      }\n\n      &.rotated-icon {\n        .layout-menuitem-icon {\n          transform: rotate(90deg);\n        }\n      }\n\n      &.active-route {\n        font-weight: 700;\n        color: var(--primary-color);\n      }\n\n      &:hover {\n        background-color: var(--surface-hover);\n      }\n\n      &:focus {\n        @include focused-inset();\n      }\n    }\n\n    ul {\n      overflow: hidden;\n      max-height: 0;\n      border-radius: $borderRadius;\n\n      li {\n        a {\n          margin-left: 1rem;\n        }\n\n        li {\n          a {\n            margin-left: 2rem;\n          }\n\n          li {\n            a {\n              margin-left: 2.5rem;\n            }\n\n            li {\n              a {\n                margin-left: 3rem;\n              }\n\n              li {\n                a {\n                  margin-left: 3.5rem;\n                }\n\n                li {\n                  a {\n                    margin-left: 4rem;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.layout-submenu-enter-active {\n  max-height: 1000px !important;\n  transition: max-height 1s ease-in-out;\n}\n\n.layout-submenu-enter-done {\n  max-height: 1000px !important;\n}\n\n.layout-submenu-exit {\n  max-height: 1000px !important;\n}\n\n.layout-submenu-exit-active {\n  overflow: hidden;\n  max-height: 0 !important;\n  transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgb(179, 177, 177);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgb(150, 150, 150);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgb(135, 135, 135);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:active {\n  background: rgb(120, 120, 120);\n  border-radius: 10px;\n}\n\n.active-item {\n\n  .submenu-text {\n    font-weight: 700 !important;\n    color: var(--primary-color);\n  }\n}\n",".layout-config-button {\n    display: block;\n    position: fixed;\n    width: 3rem;\n    height: 3rem;\n    line-height: 3rem;\n    background: var(--primary-color);\n    color: var(--primary-color-text);\n    text-align: center;\n    top: 50%;\n    right: 0;\n    margin-top: -1.5rem;\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    transition: background-color var(--transition-duration);\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 999;\n    box-shadow: -.25rem 0 1rem rgba(0,0,0,.15);\n\n    i {\n        font-size: 2rem;\n        line-height: inherit;\n        transform: rotate(0deg);\n        transition: transform 1s;\n    }\n    \n    &:hover {\n        background: var(--primary-400);\n    }\n}\n\n.layout-config-sidebar {\n    &.p-sidebar {\n        .p-sidebar-content {\n            padding-left: 2rem;\n            padding-right: 2rem;\n        }\n    }\n}\n",".layout-main-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    justify-content: space-between;\n    padding: 4.5rem 1rem 2rem 1rem;\n    transition: margin-left $transitionDuration;\n    margin-left: 300px;\n}\n\n.layout-main {\n    flex: 1 1 auto;\n}\n\n.hide-sidebar {\n    margin-left: 0;\n}\n\n.layout-mask {\n    background-color: black;\n    opacity: 0.75;\n    z-index: 50000;\n    height: 100vh;\n    width: 100vw;\n    position: relative;\n    top: 0;\n    left: 0;\n}\n",".layout-footer {\n    transition: margin-left $transitionDuration;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 1rem;\n    border-top: 1px solid var(--surface-border);\n}\n","@media screen and (min-width: 1960px) {\n  .layout-main,\n  .landing-wrapper {\n    width: 1504px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .layout-wrapper {\n    &.layout-overlay {\n      .layout-main-container {\n        margin-left: 0;\n        padding-left: 2rem;\n      }\n\n      .layout-sidebar {\n        transform: translateX(-100%);\n        left: 0;\n        top: 0;\n        height: 100vh;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      }\n\n      &.layout-overlay-active {\n        .layout-sidebar {\n          transform: translateX(0);\n        }\n      }\n    }\n\n    &.layout-static {\n      .layout-main-container {\n        margin-left: 300px;\n      }\n\n      &.layout-static-inactive {\n        .layout-sidebar {\n          transform: translateX(-100%);\n          left: 0;\n        }\n\n        .layout-main-container {\n          margin-left: 0;\n          padding-left: 2rem;\n        }\n      }\n    }\n\n    .layout-mask {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .blocked-scroll {\n    overflow: hidden;\n  }\n\n  .overlay {\n    background-color: black;\n    z-index: 500;\n  }\n\n  .layout-wrapper {\n    .layout-main-container {\n      margin-left: 0 !important;\n      padding-left: 1rem !important;\n    }\n\n    .layout-sidebar {\n      top: 0;\n      height: 100%;\n    }\n\n    .layout-mask {\n      display: block;\n      position: fixed;\n      top: 0;\n      left: 0;\n      z-index: 998;\n      width: 100%;\n      height: 100%;\n      background-color: var(--maskbg);\n    }\n\n    &.layout-mobile-active {\n      .layout-sidebar {\n        transform: translateX(0);\n      }\n    }\n  }\n}\n","/* Utils */\n.clearfix:after {\n    content: \" \";\n    display: block;\n    clear: both;\n}\n\n.card {\n    background: var(--surface-card);\n    border: 1px solid var(--surface-border);\n    padding: 2rem;\n    margin-bottom: 2rem;\n    box-shadow: var(--card-shadow);\n    border-radius: $borderRadius;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.p-toast {\n    &.p-toast-top-right,\n    &.p-toast-top-left,\n    &.p-toast-top-center {\n        top: 100px;\n    }\n}","h1, h2, h3, h4, h5, h6 {\n    margin: 1.5rem 0 1rem 0;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.2;\n    color: var(--surface-900);\n\n    &:first-child {\n        margin-top: 0;\n    }\n}\n\nh1 {\n    font-size: 2.5rem;\n}\n\nh2 {\n    font-size: 2rem;\n}\n\nh3 {\n    font-size: 1.75rem;\n}\n\nh4 {\n    font-size: 1.5rem;\n}\n\nh5 {\n    font-size: 1.25rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\nmark {\n    background: #FFF8E1;\n    padding: .25rem .4rem;\n    border-radius: $borderRadius;\n    font-family: monospace;\n}\n\nblockquote {\n    margin: 1rem 0;\n    padding: 0 2rem;\n    border-left: 4px solid #90A4AE;\n}\n\nhr {\n    border-top: solid var(--surface-border);\n    border-width: 1px 0 0 0;\n    margin: 1rem 0;\n}\n\np {\n    margin: 0 0 1rem 0;\n    line-height: 1.5;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
